export const PROPERTIES = {
    COMPANY_NAME: 'Exponet Canada Inc.',
}